const getEnv = (env) => {
  return typeof global?.Cypress?.env === 'function'
    ? global.Cypress.env(env)
    : process.env[env];
};
let localConfig = {};
if (getEnv('VUE_APP_LOCAL_SUNRISE_CONFIG')) {
  localConfig = require(process.env
    .VUE_APP_LOCAL_SUNRISE_CONFIG).default;
}
const config = {
  ct: {
    auth: {
      host:
        getEnv('VUE_APP_CT_AUTH_HOST') ||
        'https://auth.europe-west1.gcp.commercetools.com',
      projectKey:
        getEnv('VUE_APP_CT_PROJECT_KEY') || 'petsy',
      credentials: {
        clientId:
          getEnv('VUE_APP_CT_CLIENT_ID') ||
          'kqlfYuNTbk1opbluEmtBxGit',
        clientSecret:
          getEnv('VUE_APP_CT_CLIENT_SECRET') ||
          'ULJSirOsmKi0_O5uN8DZQBPC8JeP-zMg',
      },
      scope:
        getEnv('VUE_APP_CT_SCOPE') ||
        'manage_my_orders:petsy ' +
          'manage_my_profile:petsy ' +
          'manage_my_payments:petsy ' +
          'manage_products:petsy ' +
          'view_published_products:petsy ' +
          'view_categories:petsy ' +
          'manage_my_shopping_lists:petsy ' +
          'create_anonymous_token:petsy',
    },
    api:
      getEnv('VUE_APP_CT_API_HOST') ||
      'https://api.europe-west1.gcp.commercetools.com',
  },
  languages: {
    en: 'English international',
    de: 'Deutsch international',
    'de-DE': 'Deutsch',
    'en-GB': 'English',
  },
  countries: {
    DE: 'Deutschland',
    GB: 'Great Britain'
    // US: 'United States',
  },
  formats: {
    number: {
      DE: {
        currency: {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
        },
      },
      GB: {
        currency: {
          style: 'currency',
          currency: 'GBP',
          currencyDisplay: 'symbol',
        },
      },
    },
    datetime: {
      GB: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        },
      },
      DE: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        },
      },
    },
  },
  categories: {
    salesExternalId: '6',
  },
  facetSearches: [
    {
      name: 'size',
      type: 'text',
      label: {
        it: 'Size',
        de: 'Größe',
        en: 'Size',
      },
    },
    {
      name: 'color',
      type: 'lnum',
      component: 'colors',
      label: {
        de: 'Farbe',
        it: 'Color',
        en: 'Color',
      },
    },
    {
      name: 'designer',
      type: 'enum',
      component: 'designer',
      label: {
        it: 'Designer',
        de: 'Designer',
        en: 'Designer',
      },
    },
  ],
  detailAttributes: [
    {
      name: 'Sitter_gender',
      label: {
        it: 'Gender_it',
        de: 'Geschlecht',
        'de-DE': 'Geschlecht',
        en: 'Gender',
        'en-GB': 'Gender',
      },
    },
    {
      name: 'Pet_sitter_age',
      label: {
        it: 'Age_it',
        de: 'Alter',
        'de-DE': 'Alter',
        en: 'Age',
        'en-GB': 'Age',
      },
    },
    {
      name: 'Sitter_experience',
      label: {
        it: 'Experience_it',
        de: 'Erfahrung',
        'de-DE': 'Erfahrung',
        en: 'Experience',
        'en-GB': 'Experience',
      },
    },
    {
      name: 'Pet_age',
      label: {
        it: 'Age_it',
        de: 'Alter',
        'de-DE': 'Alter',
        en: 'Age',
        'en-GB': 'Age',
      },
    },
    {
      name: 'Pet_Size',
      label: {
        it: 'Size_it',
        de: 'Größe',
        'de-DE': 'Größe',
        en: 'Size',
        'en-GB': 'Size',
      },
    },
    {
      name: 'Pet_name',
      label: {
        it: 'Name_it',
        de: 'Name',
        'de-DE': 'Name',
        en: 'Name',
        'en-GB': 'Name',
      },
    },
    {
      name: 'Pet_breed',
      label: {
        it: 'Breed_it',
        de: 'Rasse',
        'de-DE': 'Rasse',
        en: 'Breed',
        'en-GB': 'Breed',
      },
    },
    {
      name: 'price-category',
      label: {
        it: 'Caretaking time_it',
        de: 'Betreungsdauer',
        'de-DE': 'Betreungsdauer',
        en: 'Caretaking time',
        'en-GB': 'Caretaking time',
      },
    },
    {
      name: 'short_description',
      label: {
        it: 'Short description_it',
        de: 'Kurze Beschreibung',
        'de-DE': 'Kurze Beschreibung',
        en: 'Short description',
        'en-GB': 'Short description',

      },
    },
    {
      name: 'Extra_information',
      label: {
        it: 'Extra information_it',
        de: 'Zusätzliche Information',
        'de-DE': 'Zusätzliche Information',
        en: 'Extra information',
        'en-GB': 'Extra information',
      },
    },
    {
      name: 'designer',
      label: {
        it: 'Designer',
        de: 'Designer',
        en: 'Designer',
      },
    },
    {
      name: 'colorFreeDefinition',
      label: {
        it: 'Color',
        de: 'Farbe',
        en: 'Color',
      },
    },
    {
      name: 'size',
      label: {
        it: 'Size',
        de: 'Grösse',
        en: 'Size',
      },
    },
    {
      name: 'style',
      label: {
        it: 'Style',
        de: 'Stil',
        en: 'Style',
      },
    },
    {
      name: 'gender',
      label: {
        it: 'Gender',
        de: 'Zielgruppe',
        en: 'Gender',
      },
    },
    {
      name: 'articleNumberManufacturer',
      label: {
        it: 'Manufacturer AID',
        de: 'Herstellernummer',
        en: 'Manufacturer AID',
      },
    },
  ],
  variantSelector: ['color', 'size', 'price-category'],
  variantInProductName: ['size', 'price-category'],
  ...localConfig,
};
// eslint-disable-next-line no-console
console.log('using config:', config);
export default config;
